import React, { useEffect, useState } from "react";
import { Container, Flex, Link as ChakraLink, Text } from "@chakra-ui/react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appRoutes } from "../../../App";
import { t } from "i18next";
import { OsaCommentApi } from "../../coding/services/OsaCommentApi";
import {
  AppHeader,
  AppHeaderHeight,
} from "../../shared/views/AppHeader/AppHeader";
import { LoadingScreen } from "../../shared/views/LoadingScreen/LoadingScreen";
import { OsaWayApi } from "../../osaway/services/OsaWayApi";
import { CampaignApi } from "../../project/services/CampaignApi";

export const CommentRedirectPage: React.FC = () => {
  const commentId = useParams().commentId!;

  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const loadContextAndRedirect = async () => {
    const comment = await OsaCommentApi.get(commentId).then((r) => r.data);
    const osaWay = await OsaWayApi.get(comment.osaWayId).then((r) => r.data);
    const campaign = await CampaignApi.get(osaWay.campaignId).then(
      (r) => r.data
    );

    const urlParams = new URLSearchParams();
    urlParams.append("osaWayId", osaWay.id);

    if (comment.osaNodeId) {
      urlParams.append("osaNodeId", comment.osaNodeId);
    }

    if (osaWay.permissions.canCode || osaWay.permissions.canComment) {
      navigate(
        `${appRoutes.project(campaign.projectId)}?${urlParams.toString()}`
      );
    } else {
      setShowError(true);
    }
  };

  useEffect(() => {
    loadContextAndRedirect().catch(() => {
      setShowError(true);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Flex flexDir="column" maxHeight="100vh" flexGrow={1} position="relative">
      <AppHeader />
      <AppHeaderHeight />

      {showError ? (
        <Container py={8}>
          <Text fontSize="2xl">{t(`map:comments.unavailable`)}</Text>
          <ChakraLink color="primary.600">
            <Link to={"/"}>{t(`map:comments.goHome`)}</Link>
          </ChakraLink>
        </Container>
      ) : (
        <LoadingScreen />
      )}
    </Flex>
  );
};
